import { z } from "zod";
export const templateCategory = z.enum(["marketing", "utility", "authentication"]);
export const templateLanguage = z.enum(["ms", "en"]);
export const templateStatus = z.enum([
    "draft",
    "pending",
    "approved",
    "rejected",
    "paused",
    "disabled",
]);
export const templateVariable = z.object({ index: z.number().int().positive(), label: z.string() });
/** Header media above the body. Only IMAGE is supported (doc 05 §3); "none" = body-only. */
export const templateHeaderFormat = z.enum(["none", "image"]);
export const templateCreateInput = z.object({
    name: z.string().min(1).max(512),
    displayName: z.string().max(120).optional(),
    category: templateCategory,
    language: templateLanguage.default("ms"),
    body: z.string().min(1).max(1024),
    variables: z.array(templateVariable).default([]),
    headerFormat: templateHeaderFormat.default("none"),
    // Media row id of the uploaded sample image (POST /api/v1/media) — Meta requires
    // an example image with the approval submission when headerFormat is "image".
    headerSampleMediaId: z.number().int().optional(),
});
export const template = z.object({
    id: z.number().int(),
    name: z.string(),
    displayName: z.string().nullable(),
    category: templateCategory,
    language: templateLanguage,
    body: z.string(),
    variables: z.array(templateVariable),
    headerFormat: templateHeaderFormat.default("none"),
    /** Default header image for sends (0018): local media id, null = per-broadcast. */
    defaultHeaderMediaId: z.number().int().nullable().default(null),
    status: templateStatus,
    rejectedReason: z.string().nullable(),
    submittedAt: z.string().nullable(),
    decidedAt: z.string().nullable(),
});
//# sourceMappingURL=template.js.map